export const Namespace = 'Notifications';
export enum NotificationAction {
    ClearAll = 'CLEAR_ALL'
};


// WEBPACK FOOTER //
// ./src/sharebase-app/components/notifications/notifications.actions.ts